import * as classNames from 'classnames';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import PayoutMethodOptions from './payout_method_options';

class DirectCheckoutProfile extends React.Component {
  get profileContainerClass() {
    return classNames(
      'dc_form',
      { 'global-slidedown--open': this.props.selected },
      { 'global-slidedown--closed': !this.props.selected },
    );
  }

  render() {
    return (
      <div
        className={this.profileContainerClass}
        data-direct-checkout-profile-form
      >
        <div className="margined-left module panel mb-2">
          <PayoutMethodOptions {...this.props} />
        </div>
      </div>
    );
  }
}

DirectCheckoutProfile.propTypes = {
  profileAttributes: PropTypes.object.isRequired,
  payoutCurrencies: PropTypes.object.isRequired,
  hideBankAccountEditForm: PropTypes.bool.isRequired,
  shopLocatedInUs: PropTypes.bool.isRequired,
  dcProfileComplete: PropTypes.bool,
  bankLookupUrl: PropTypes.string.isRequired,
  preferredSeller: PropTypes.bool,
  hasCompletedPayouts: PropTypes.bool,
  countryCodeOptions: PropTypes.array.isRequired,
  formPrefix: PropTypes.string.isRequired,
  reverbBankCurrencies: PropTypes.array.isRequired,
  selected: PropTypes.bool,
  shopCurrency: PropTypes.string.isRequired,
  onCountryChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
};

// onCountryChange is only used when this component
// is rendered inside of PaymentMethodSelection
DirectCheckoutProfile.defaultProps = {
  onCountryChange: () => null,
  onCurrencyChange: () => null,
};

export default DirectCheckoutProfile;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/shop_policies/direct_checkout_profile.jsx